export default __webpack_public_path__ + "static/media/BlackLogo.7e716880.svg";